import React from "react";
import { Globe, Check } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

const LanguageSwitcher = ({ compact }) => {
  const { lang, setLang, languages, t } = useI18n();
  const current = languages.find((l) => l.code === lang) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          aria-label={t("selectLanguage")}
          className="inline-flex items-center gap-1.5 h-10 px-3 rounded-full hover:bg-slate-100 transition-colors text-[#0a2540]"
        >
          <Globe className="w-5 h-5" />
          <span className="text-sm font-600">{current.short}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            className="flex items-center justify-between cursor-pointer"
          >
            <span className={l.code === lang ? "font-600 text-[#0a6ed1]" : ""}>{l.label}</span>
            {l.code === lang && <Check className="w-4 h-4 text-[#0a6ed1]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
